// components/SupportButton.js
import React from 'react';
import { TouchableOpacity, Text, StyleSheet, Linking, View } from 'react-native';

export default function SupportButton() {
  const handleSupportPress = () => {
    Linking.openURL(
      'mailto:ecryptoua@gmail.com?subject=Підтримка%ecrypto&body=Опишіть вашу проблему...'
    );
  };

  return (
    <View style={styles.wrapper}>
      <TouchableOpacity style={styles.button} onPress={handleSupportPress}>
        <Text style={styles.text}>Підтримка: ecryptoua@gmail.com</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    marginTop: 40,
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  button: {
    paddingVertical: 6,
    paddingHorizontal: 14,
    backgroundColor: '#e0e0e0',
    borderRadius: 20,
  },
  text: {
    fontSize: 12,
    color: '#333',
  },
});
